import { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

/** Input comune/regione con suggerimenti (tutti i comuni italiani). onSelect riceve {nome, tipo, regione, provincia, cap}. */
export function LuogoInput({ value, onChange, onSelect, placeholder = "Comune o Regione", className = "", inputClassName = "", testid = "luogo-input", autoSubmit, required }) {
  const [sugg, setSugg] = useState([]);
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(-1);
  const picked = useRef(false);
  useEffect(() => {
    if (!open || (value || "").trim().length < 2 || picked.current) { setSugg([]); return; }
    const t = setTimeout(() => api.get("/public/luoghi", { params: { q: value } }).then((r) => { setSugg(r.data); setIdx(-1); }).catch(() => setSugg([])), 180);
    return () => clearTimeout(t);
  }, [value, open]);
  const scegli = (o) => { picked.current = true; onChange(o.nome); onSelect?.(o); setOpen(false); setSugg([]); if (autoSubmit) setTimeout(autoSubmit, 0); setTimeout(() => { picked.current = false; }, 300); };
  const onKey = (e) => {
    if (!sugg.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setIdx((i) => Math.min(i + 1, sugg.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setIdx((i) => Math.max(i - 1, 0)); }
    else if (e.key === "Enter" && idx >= 0) { e.preventDefault(); scegli(sugg[idx]); }
    else if (e.key === "Escape") setOpen(false);
  };
  return (
    <div className={`relative ${className}`}>
      <Input value={value} required={required} onChange={(e) => { picked.current = false; onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} onKeyDown={onKey} placeholder={placeholder} autoComplete="off" className={inputClassName} data-testid={testid} role="combobox" aria-expanded={open && sugg.length > 0} />
      {open && sugg.length > 0 && (
        <ul className="absolute left-0 top-full mt-1 z-40 w-full min-w-[260px] rounded-xl border border-slate-200 bg-white shadow-lg overflow-hidden" data-testid={`${testid}-suggerimenti`} role="listbox">
          {sugg.map((o, i) => (
            <li key={o.tipo + o.nome + o.provincia}><button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => scegli(o)} className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 ${i === idx ? "bg-slate-100" : "hover:bg-slate-50"} text-slate-800`} role="option" aria-selected={i === idx} data-testid={`${testid}-opzione-${o.nome.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}>
              <MapPin size={13} className="text-[#0070BA] shrink-0" /><span className="truncate">{o.nome}</span><span className="ml-auto text-[11px] text-slate-400 shrink-0">{o.tipo === "regione" ? "Regione" : `${o.provincia} · ${o.regione}`}</span>
            </button></li>))}
        </ul>
      )}
    </div>
  );
}
